// extracted by mini-css-extract-plugin
export default {"container":"fB","promoapplied":"gB","tobeapplied":"hB","hr":"iB","teal":"jB","promoappliedcontainer":"kB","error":"lB","input":"mB","errorInput":"nB","promo_x":"oB","promo_info":"pB","promoxcontainer":"qB"};
    if(module.hot) {
      // 1713361650701
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  